// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Berkshire+Swash&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.cdnfonts.com/css/sansation);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/Components/About.css */

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Sansation', sans-serif;
}

.about-container {
  display: flex;
  flex-direction: column;
  justify-content: center; /* Center vertically */
  align-items: center;
  padding: 20px;
  text-align: center;
  min-height: 100vh; /* Fill screen height */
}

h1 {
  font-size: 90px;
  font-family: 'Berkshire Swash', cursive;
  margin: 0;
  word-wrap: break-word;
}

.animate-gradient-text {
  background-image: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
  background-size: 200%;
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  animation: animated-gradient 5s ease infinite;
}

@keyframes animated-gradient {
  0%, 100% {
    background-position: 0 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.about {
  font-size: 28px;
  margin: 0 10px;
}

@media screen and (max-width: 800px) {
  h1 {
    font-size: 50px;
    line-height: 1.1;
  }
  .about {
    font-size: 18px;
    margin: 0 5px;
  }
}

#continue_main {
  background: #bffd2d;
  border: none;
  font-size: 25px;
  border-radius: 10px;
  width: 250px;
  height: 50px;
  cursor: pointer;
}

.continue {
  margin-top: 20px;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Components/About.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAI7B;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB,EAAE,sBAAsB;EAC/C,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,iBAAiB,EAAE,uBAAuB;AAC5C;;AAEA;EACE,eAAe;EACf,uCAAuC;EACvC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,6EAA6E;EAC7E,qBAAqB;EACrB,oCAAoC;EACpC,6BAA6B;EAC7B,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* src/Components/About.css */\r\n@import url('https://fonts.googleapis.com/css2?family=Berkshire+Swash&display=swap');\r\n@import url('https://fonts.cdnfonts.com/css/sansation');\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: 'Sansation', sans-serif;\r\n}\r\n\r\n.about-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center; /* Center vertically */\r\n  align-items: center;\r\n  padding: 20px;\r\n  text-align: center;\r\n  min-height: 100vh; /* Fill screen height */\r\n}\r\n\r\nh1 {\r\n  font-size: 90px;\r\n  font-family: 'Berkshire Swash', cursive;\r\n  margin: 0;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.animate-gradient-text {\r\n  background-image: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);\r\n  background-size: 200%;\r\n  -webkit-text-fill-color: transparent;\r\n  -webkit-background-clip: text;\r\n  background-clip: text;\r\n  animation: animated-gradient 5s ease infinite;\r\n}\r\n\r\n@keyframes animated-gradient {\r\n  0%, 100% {\r\n    background-position: 0 50%;\r\n  }\r\n  50% {\r\n    background-position: 100% 50%;\r\n  }\r\n}\r\n\r\n.about {\r\n  font-size: 28px;\r\n  margin: 0 10px;\r\n}\r\n\r\n@media screen and (max-width: 800px) {\r\n  h1 {\r\n    font-size: 50px;\r\n    line-height: 1.1;\r\n  }\r\n  .about {\r\n    font-size: 18px;\r\n    margin: 0 5px;\r\n  }\r\n}\r\n\r\n#continue_main {\r\n  background: #bffd2d;\r\n  border: none;\r\n  font-size: 25px;\r\n  border-radius: 10px;\r\n  width: 250px;\r\n  height: 50px;\r\n  cursor: pointer;\r\n}\r\n\r\n.continue {\r\n  margin-top: 20px;\r\n  text-align: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
